module.exports = __webpack_public_path__ + "static/img/newHuaiC6.9cf3051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC6.png
// module id = 3mC1
// module chunks = 0